import { ApolloClient, gql, NormalizedCacheObject, useQuery } from '@apollo/client';
import { useUserContext } from 'context/User.context';
import { serveMaintenancePageConstants } from './auth.service';
const FeatureToggle = gql`
  query featureToggle($teamid: Int, $costcenterid: Int, $origin: String, $id: Int) {
    feature(
      where: {
        _or: [
          {
            costcenter_feature_toggles: {
              costcenter_id: { _eq: $costcenterid }
              _and: { is_deleted: { _eq: false } }
            }
          }
          {
            user_feature_toggles: {
              team_id: { _eq: $teamid }
              _and: { is_deleted: { _eq: false } }
            }
          }
        ]
        is_active: { _eq: true }
        is_deleted: { _eq: false }
      }
    ) {
      name
    }
    arc_maintenance_page(where: { origin: { _eq: $origin }, id: { _eq: $id } }) {
      is_under_maintenance
      page_name
      id
      origin
    }
    arc_submission_wizard(where: { origin: { _eq: $origin }, id: { _eq: $id } }) {
      page_name
      wizard_under_maintenance
      id
      origin
    }
  }
`;
export type FeatureToggleResponse = {
  feature: Array<{ name: string }>;
  arc_maintenance_page: Array<{
    is_under_maintenance: boolean;
    page_name: string;
    id: number;
    origin: string;
  }>;
  arc_submission_wizard: Array<{
    page_name: string;
    wizard_under_maintenance: boolean;
    id: number;
    origin: string;
  }>;
};

export default function useGetFeature(client?: ApolloClient<NormalizedCacheObject>): {
  listOfFeatures: {
    name: string;
  }[];
  accessableFeature: any[];
  underMaintenance: boolean;
  wizardUnderMaintenance: boolean;
  loading: boolean;
  error: any;
} {
  const { myUser } = useUserContext();
  const maintenancePageConstants = serveMaintenancePageConstants();
  const { data, loading, error } = useQuery<FeatureToggleResponse>(FeatureToggle, {
    variables: {
      teamid: myUser?.userId,
      costcenterid: myUser?.costCenter,
      origin: maintenancePageConstants.origin,
      id: maintenancePageConstants.id
    },
    skip:
      !myUser?.userId ||
      !myUser?.costCenter ||
      !maintenancePageConstants.origin ||
      !maintenancePageConstants.id,
    client,
    fetchPolicy: 'network-only'
  });
  const accessableFeature = data?.feature || [];
  const isUnderMaintenance = data?.arc_maintenance_page[0].is_under_maintenance;

  return {
    listOfFeatures: data?.feature || [],
    accessableFeature: accessableFeature || [],
    underMaintenance: isUnderMaintenance || false,
    wizardUnderMaintenance: data?.arc_submission_wizard[0]?.wizard_under_maintenance || false,
    loading,
    error
  };
}
